import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { noteIdOf } from "@/utils/nip19"

const INTERACTIVE = "a, button, input, textarea, select, video, audio, [data-no-note-nav]"

/**
 * Opens the note detail view when the card is clicked or activated with the
 * keyboard. Clicks on links, buttons and media controls are left untouched so
 * nested actions keep working.
 */
export function useNoteNavigation(eventId: string | undefined, disabled = false) {
  const navigate = useNavigate()

  const openNote = useCallback(
    (event: React.MouseEvent | React.KeyboardEvent) => {
      if (disabled || !eventId) return
      if ("key" in event) {
        if (event.key !== "Enter" && event.key !== " ") return
        if (event.target !== event.currentTarget) return
        event.preventDefault()
      } else {
        const target = event.target as HTMLElement | null
        if (target?.closest(INTERACTIVE)) return
        if (event.defaultPrevented) return
        // Do not navigate when the user was selecting text.
        const selection = window.getSelection()
        if (selection && selection.toString().length > 0) return
      }
      navigate(`/n/${noteIdOf(eventId)}`)
    },
    [disabled, eventId, navigate],
  )

  return { openNote }
}
